import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Modal, Select, message } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createReport } from '@/apis/reports';
import usePrivateAction from '@/utils/usePrivateAction';
import { logicalRequest } from '@/utils/logicalRequest';
import { FlagOutlined } from '@ant-design/icons';
import DialogHeading from '@/components/dialogheading';

export const reportReasons = { spam: '广告或垃圾信息', harassment: '骚扰或辱骂', fraud: '欺诈', inappropriate: '不当内容', other: '其他' };
export const reportStatuses = { pending: '待受理', reviewing: '处理中', resolved: '已结案', rejected: '已驳回' };
export const targetTypes = { post: '帖子', comment: '评论', user: '用户' };
export const ReportDialog = ({ targetType, targetId, authorId, open, onClose }) => {
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  const [form] = Form.useForm(); const requestRef = useRef(null);
  const { busy, run } = usePrivateAction();
  const context = `${sessionVersion}:${userInfo?.id}:${targetType}:${targetId}`;
  useEffect(() => { requestRef.current = null; form.resetFields(); }, [context, open, form]);
  if (!isAuthenticated || !targetId || (userInfo?.id != null && String(userInfo.id) === String(authorId))) return null;
  return <Modal centered width={520} aria-label={`举报${targetTypes[targetType]}`} title={<DialogHeading icon={<FlagOutlined />} title={`举报${targetTypes[targetType]}`} description="请说明需要核查的问题，管理员将人工处理" />} open={open} footer={null} onCancel={() => !busy && onClose()} closable={!busy} mask={{ closable: !busy }}>
      <Form name={`report-${targetType}-${targetId}`} key={context} form={form} layout="vertical" disabled={busy} onFinish={values => run(() => createReport(logicalRequest(requestRef, {
        target_type: targetType, target_id: String(targetId), reason: values.reason, description: values.description.trim(),
      })), () => { onClose(); requestRef.current = null; message.success('举报已提交，可在“我的举报”查看处理进度'); })}>
        <Form.Item name="reason" label="举报原因" rules={[{ required: true, message: '请选择举报原因' }]}><Select placeholder="选择最符合的原因" options={Object.entries(reportReasons).map(([value, label]) => ({ value, label }))} /></Form.Item>
        <Form.Item name="description" label="问题说明" rules={[{ required: true, whitespace: true, message: '请填写问题说明' }]}><Input.TextArea placeholder="请描述具体问题，帮助管理员核查" maxLength={2000} showCount autoSize={{ minRows: 4, maxRows: 10 }} /></Form.Item>
        <div className="dialogForm-actions"><Button disabled={busy} onClick={onClose}>取消</Button><Button type="primary" htmlType="submit" loading={busy}>提交举报</Button></div>
      </Form>
    </Modal>;
};

const ReportButton = ({ targetType, targetId, authorId }) => {
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const context = `${sessionVersion}:${isAuthenticated}:${userInfo?.id}:${targetType}:${targetId}`;
  useEffect(() => { setOpen(false); }, [context]);
  if (!targetId || (userInfo?.id != null && String(userInfo.id) === String(authorId))) return null;
  return <><Button type="text" size="small" onClick={() => {
    if (!isAuthenticated) { message.warning('请先登录后举报'); navigate('/login'); return; }
    setOpen(true);
  }}>举报{targetTypes[targetType]}</Button>
    {open && <ReportDialog {...{ targetType, targetId, authorId, open }} onClose={() => setOpen(false)} />}
  </>;
};
export default ReportButton;
